import { createSelector } from 'reselect';
import { RootState } from '../../../types';
import { EntityTypes } from '../../../constants/entities';
import { IEntityReducer } from 'core/reducers/entities';
import { getEntities } from '../utils/getEntities';
import { IVerification } from 'types/domain/verification';

const entity = (state: RootState) => state.entity.present;

export const selectVerifications = createSelector([entity], (entity: IEntityReducer) => {
  return Object.values(entity[EntityTypes.VERIFICATION])
    .filter(g => g.status > -1)
    .map((verification: IVerification) => parseVerification(entity, verification.id, null));
});

export function parseVerification(entity, id, courseNodeId) {
  const verification = entity[EntityTypes.VERIFICATION][id];
  return {
    ...verification,
    tags: getEntities(entity, EntityTypes.TAG_JOIN, 'verificationId', verification.id),
    entities: getEntities(entity, EntityTypes.VERIFICATION_ENTITY, 'verificationId', verification.id).filter(e =>
      courseNodeId ? e.courseNodeId === courseNodeId : true,
    ),
  };
}
